import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './css/avisResto.css';
import Image1 from '../../Image/avatar1.png';
import Image2 from '../../Image/Avatar2.png';
import Spinner from "react-bootstrap/Spinner";
import Pagination from '@material-ui/lab/Pagination';
import { toast } from 'react-toastify';

import { AfficheAvisNote, RepondreAvis } from '../../Api/RestaurantApi/AvisNoteApi';

const Avis = () => {
    const [loadData, setLoadData] = useState(false);
    const [loading, setLoading] = useState(false);
    const [note, setNote] = useState([]);
    const [dataAvis, setDataAvis] = useState([]);
    const [data, setData] = useState([]);
    const [idAvis, setIdAvis] = useState('');
    const [showPaginate, setShowPaginate] = useState(true);
    const [totalPage, setTotalPage] = useState();
    const [page, setPage] = useState(1);
    const [reponseAvis, setReponseAvis] = useState('');

    const [modalShow, setModalShow] = useState(false);
    const [openDropDown, setOpenDropDown] = useState(false);

    let location = useLocation();
    const restaurant = useSelector((state) => state.restaurant);



    useEffect(() => {
        AfficheAvisNoteResto();
        if (dataAvis.length < 4) {
            setShowPaginate(false);
        } else {
            setShowPaginate(true);
        }
    }, [dataAvis.length]);

    const AfficheAvisNoteResto = (value = null) => {
        let dataPage = value === null ? page : value;
        setLoadData(true);
        AfficheAvisNote(restaurant.id, dataPage)
            .then(function (response) {
                console.log("data =>", response.data.donner);
                setData(response.data.donner);
                setDataAvis(response.data.reservations);
                response.data.reservations.map((item) => {
                    return setNote((prev) => [...prev, { note: item.notes[0]?.note }])
                })
                console.log("total avis=>", response.data.reservations);
                setTotalPage(response.data.totalPage);
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                setLoadData(false);
            });
    };

    console.log("data=>", data);

    const safeParseFloat = (str) => {
        const value = Number.parseFloat(str);

        return Number.isNaN(value) ? 0 : value;
    };
    const formatPlural = (value) => {
        if (value < 10) {
            return "0" + value;
        } else {
            return value;
        }
    };

    const formatDate = (date) => {
        const datePrise = new Date(date);
        return (
            formatPlural(datePrise.getDate()) +
            "/" +
            formatPlural(datePrise.getUTCMonth() + 1) +
            "/" +
            datePrise.getFullYear()
        );
    };


    const formatTime = (time) => {
        return formatPlural(new Date(time).getHours()) + "H: " + formatPlural(new Date(time).getMinutes());
    };


    const handleReponse = (idAvis) => {
        setModalShow(true)
        setIdAvis(idAvis);
    }


    const viewAvisNote = (item, index) => {

        const nom = item.client.nom.charAt(0).toUpperCase();
        const prenom = item.client.prenom.charAt(0).toUpperCase();

        const expireDate = new Date(item.reservation.datePrise);
        const endDate = expireDate.setDate(expireDate.getDate() + 30);

        const profilClient = data?.filter((el) => el.client.id === item.client.id);

        if (item.avis === null && item.reponse === null) {
            return (
                <div className='liste_avis mt-3' key={index}>

                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-2'>
                            <div className='d-flex'>
                                <div className='pseudo'>
                                    <div>
                                        <div className="d-flex justify-content-center">
                                            <div className="avatar">
                                                {item.client.sexe === "Homme" ?
                                                    <img src={Image2} alt="avatar Client" />
                                                    :
                                                    <img src={Image1} alt="avatar Client" />
                                                }
                                            </div>
                                        </div>

                                        {item.client.affichagePseudo === "1" ?
                                            <div className='d-flex justify-content-center'>
                                                <div className='d-flex flex-column'>
                                                    <span>{item.client.nom}</span>
                                                    <span className='text-center'>{item.client.prenom}</span>
                                                </div>
                                            </div>
                                            : item.client.affichagePseudo === "2" ?
                                                <div className='d-flex justify-content-center'>
                                                    <span>{item.client.prenom} {nom}</span>
                                                </div>
                                                : item.client.affichagePseudo === "3" ?
                                                    <div className='d-flex justify-content-center'>
                                                        <span>{prenom} {item.client.prenom}</span>
                                                    </div>
                                                    :
                                                    <div className='d-flex justify-content-center'>
                                                        <span>{nom} {prenom}</span>
                                                    </div>
                                        }
                                        {profilClient && (
                                            profilClient.length === 1 ? (
                                                <span>Un seul avis déposé</span>
                                            ) : profilClient.length >= 2 && profilClient.length <= 4 ? (
                                                <span>Commence à s’y connaitre</span>
                                            ) : profilClient.length >= 10 ? (
                                                <span>Expert</span>
                                            ) : (
                                                ""
                                            )
                                        )}
                                    </div>
                                </div>
                                <div className='reservation'>
                                    <div>
                                        <div><span className="date">Réservation du  {formatDate(item.reservation.datePrise)}</span></div>
                                        <div className='mt-2'><span>à {formatTime(item.reservation.heurePrise)}</span></div>
                                        <div> <span>Pour {item.reservation.nombrePersonne} personnes</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-2'>
                            {new Date() < endDate ?
                                <div className='avis_attent'>
                                    <div className='d-flex justify-content-center'>
                                        <h3 className='text-center'>Attente dépôt client </h3>
                                    </div>
                                </div>
                                : <div className='avis_vide'>
                                    <div className='d-flex justify-content-center'>
                                        <h3 className='text-center'>Pas d’avis déposé par le client</h3>
                                    </div>
                                </div>}


                        </div>
                    </div>

                </div>
            )
        } else if (item.avis !== null && item.reponse === null) {

            return (
                <div className='liste_avis' key={index} onClick={() => setOpenDropDown(false)}>
                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-2'>
                            <div className='d-flex'>
                                <div className='pseudo'>
                                    <div>
                                        <div className='d-flex justify-content-center'>
                                            <div className="avatar">
                                                {item.client.sexe === "Homme" ?
                                                    <img src={Image2} alt="avatar Client" />
                                                    :
                                                    <img src={Image1} alt="avatar Client" />
                                                }

                                            </div>
                                        </div>
                                        {item.client.affichagePseudo === "1" ?
                                            <div className='d-flex justify-content-center'>
                                                <div className='d-flex flex-column'>
                                                    <span>{item.client.nom}</span>
                                                    <span className='text-center'>{item.client.prenom}</span>
                                                </div>
                                            </div>
                                            : item.client.affichagePseudo === "2" ?
                                                <div className='d-flex justify-content-center'>
                                                    <span>{item.client.prenom} {nom}</span>
                                                </div>
                                                : item.client.affichagePseudo === "3" ?
                                                    <div className='d-flex justify-content-center'>
                                                        <span>{prenom} {item.client.prenom}</span>
                                                    </div>
                                                    :
                                                    <div className='d-flex justify-content-center'>
                                                        <span>{nom} {prenom}</span>
                                                    </div>
                                        }
                                        {profilClient && (
                                            profilClient.length === 1 ? (
                                                <span>Un seul avis déposé</span>
                                            ) : profilClient.length >= 2 && profilClient.length <= 4 ? (
                                                <span>Commence à s’y connaitre</span>
                                            ) : profilClient.length >= 10 ? (
                                                <span>Expert</span>
                                            ) : (
                                                ""
                                            )
                                        )}
                                    </div>
                                </div>
                                <div className='reservation'>
                                    <div>
                                        <div><span className="date">Réservation du  {formatDate(item.reservation.datePrise)}</span></div>
                                        <div className='mt-2'><span>à {formatTime(item.reservation.heurePrise)}</span></div>
                                        <div> <span>Pour {item.reservation.nombrePersonne} personnes</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-2'>
                            <div className='avis_resto'>
                                <div className='d-flex'>
                                    <div className='avis_apropos'>
                                        <div className='d-flex justify-content-between'>
                                            <span> {formatDate(item.createdAt)}</span>
                                            <span>{item.notes[0]?.note}/20</span>
                                        </div>
                                        <p>{item.avis}</p>
                                    </div>
                                    <div className='action'>
                                        <button className='btn' onClick={() => handleReponse(item.id)}>Répondre</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className='liste_avis mt-3' key={index} onClick={() => setOpenDropDown(false)}>

                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-2'>
                            <div className='d-flex'>
                                <div className='pseudo'>
                                    <div>
                                        <div className='d-flex justify-content-center'>
                                            <div className="avatar">
                                                {item.client.sexe === "Homme" ?
                                                    <img src={Image2} alt="avatar Client" />
                                                    :
                                                    <img src={Image1} alt="avatar Client" />
                                                }
                                            </div>
                                        </div>
                                        {item.client.affichagePseudo === "1" ?
                                            <div className='d-flex justify-content-center'>
                                                <div className='d-flex flex-column'>
                                                    <span>{item.client.nom}</span>
                                                    <span className='text-center'>{item.client.prenom}</span>
                                                </div>
                                            </div>
                                            : item.client.affichagePseudo === "2" ?
                                                <div className='d-flex justify-content-center'>
                                                    <span>{item.client.prenom} {nom}</span>
                                                </div>
                                                : item.client.affichagePseudo === "3" ?
                                                    <div className='d-flex justify-content-center'>
                                                        <span>{prenom} {item.client.prenom}</span>
                                                    </div>
                                                    :
                                                    <div className='d-flex justify-content-center'>
                                                        <span>{nom} {prenom}</span>
                                                    </div>
                                        }
                                        {profilClient && (
                                            profilClient.length === 1 ? (
                                                <span>Un seul avis déposé</span>
                                            ) : profilClient.length >= 2 && profilClient.length <= 4 ? (
                                                <span>Commence à s’y connaitre</span>
                                            ) : profilClient.length >= 10 ? (
                                                <span>Expert</span>
                                            ) : (
                                                ""
                                            )
                                        )}
                                    </div>
                                </div>
                                <div className='reservation'>
                                    <div>
                                        <div><span className="date">Réservation du  {formatDate(item.reservation.datePrise)}</span></div>
                                        <div className='mt-2'><span>à {formatTime(item.reservation.heurePrise)}</span></div>
                                        <div> <span>Pour {item.reservation.nombrePersonne} personnes</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-2'>
                            <div className='avis_resto'>
                                <div className='d-flex'>
                                    <div className='avis_apropos'>
                                        <div className='d-flex justify-content-between'>
                                            <span> {formatDate(item.createdAt)}</span>
                                            <span>{item.notes[0]?.note}/20</span>
                                        </div>
                                        <p>{item.avis}</p>
                                    </div>
                                    <div className='effectuer'>
                                        <span>Retour effectué éventuellement</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            )
        }
    }


    const viewNote = () => {
        const notes = safeParseFloat(
            note.reduce(
                (prevNote, currentNote) => prevNote + parseInt(currentNote.note),
                0
            ) / note.length
        );
        return notes.toFixed(2);
    }
    console.log("note =>", note);


    const handleRepondreAvis = () => {
        setLoading(true);
        const data = { idAvis: idAvis, reponse: reponseAvis };
        RepondreAvis(data).then(function (response) {
            if (response.data.title === "success") {
                toast.success(response.data.message);
                AfficheAvisNoteResto();
            }
        }).catch(function (error) {
            console.log(error.response);
            toast.warning(error.response.data.message);
        }).finally(function () {
            setReponseAvis('');
            setLoading(false);
            setModalShow(false);
        });
    }

    const handlePage = (event, value) => {
        setPage(value);
        AfficheAvisNoteResto(value);
    }


    const handleDrop = () => {
        setOpenDropDown(!openDropDown);
    }


    const handleReset = () => {
        AfficheAvisNoteResto();
    }



    const handleCroissonAvis = () => {
        const sorted = [...dataAvis].sort((a, b) => a.id > b.id ? 1 : -1);
        setData(sorted);
    }

    const handleDeCroissonAvis = () => {
        const sorted = [...dataAvis].sort((a, b) => a.id < b.id ? 1 : -1);
        setData(sorted);
    }

    const handleCroissonNote = () => {
        const sorted = [...dataAvis].sort((a, b) => parseFloat(a.notes[0]?.note) > parseFloat(b.notes[0]?.note) ? 1 : -1);
        setData(sorted);
    }

    const handleDeCroissonNote = () => {
        const sorted = [...dataAvis].sort((a, b) => parseFloat(a.notes[0]?.note) < parseFloat(b.notes[0]?.note) ? 1 : -1);
        setData(sorted);
    }





    return (
        <div>
            <Helmet>
                <title>Avis/Notes</title>
                <meta name='description' content='Restaurant notes et avis .' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='avis'>
                <div className='container'>
                    <div className='bloc_avis'>
                        <div className='titre_avis'>
                            <div className='d-flex mt-2 titre'>
                                <i className='fa fa-question-circle'></i> <h1>Avis déposés sur votre restaurant</h1>
                            </div>
                            <div className='avis_renseignement'>
                                <div className='row'>
                                    <div className='col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10'>
                                        <p>Ces avis vous aident à identifier les points forts et les axes d'amélioration de votre restaurant.
                                            Vous n’êtes pas obligé de répondre aux avis déposés. Cependant, il est fortement conseiller
                                            de le faire surtout en cas d’avis négatif et/ou note inférieure à la moyenne.
                                            Et surtout, restez courtois car votre retour sera visible par tous !
                                        </p>
                                        <p>Nbre avis: {dataAvis.length}</p>
                                    </div>
                                    <div className='col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2'>
                                        <div className='d-flex justify-content-center'>
                                            {dataAvis.length !== 0 ? <button className='btn btn_trier' onClick={handleDrop}>Trier par :</button> : ""}
                                        </div>
                                        <div className='d-flex justify-content-center'>
                                            <div className='note_resto'>
                                                {viewNote()}/20
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-xs-12 col-12 col-sm-12'>
                                    <div className='d-flex justify-content-end'>
                                        <div className={openDropDown === true ? "body-filter show" : "body-filter"}>
                                            <div className="filter-content">
                                                <div className="filter_titre">
                                                    <li className='filter_resa'>Avis</li>
                                                    <li className='filter_note'>Note</li>
                                                </div>
                                                <div className="filter-value">
                                                    <div className="body-valueResa">
                                                        <span onClick={handleCroissonAvis}>Croissant</span>
                                                        <span className='ms-3' onClick={handleDeCroissonAvis}>Décroissant</span>
                                                    </div>
                                                    <div className="body-valueNote">
                                                        <span onClick={handleCroissonNote}>Croissant</span>
                                                        <span className='ms-3' onClick={handleDeCroissonNote}>Décroissant</span>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="footer-value">
                                                <div className="action">
                                                    <button className="btn btn_reinitialiser btn-sm" onClick={handleReset}>
                                                        Reinitialiser
                                                    </button>
                                                    <button className="btn btn_fermerFilter btn-sm" onClick={() => setOpenDropDown(false)}>
                                                        Fermer
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='content_avis'>

                            {loadData === true ?
                                <div className="d-flex justify-content-center">
                                    <Spinner
                                        animation="border"
                                        className="load"
                                        variant="info"
                                        size="md"
                                    />
                                </div> : data.map((item, index) => {
                                    return viewAvisNote(item, index);
                                })
                            }
                            {showPaginate && <div className='d-flex justify-content-center mt-4'>
                                <Pagination
                                    shape="rounded"
                                    count={Math.ceil(totalPage)}
                                    onChange={handlePage}
                                />
                            </div>
                            }
                            <p className='version'>Version 1</p>
                        </div>

                    </div>
                    <Modal
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        <Modal.Body>
                            <div className='modal_avis'>
                                <div className='modal_titreAvis'>
                                    <h5 className='text-center'>Droit de réponse à un avis</h5>
                                    <p>Votre avis sera publié tel quel.
                                        Merci de bien vous relire avant validation et de rester courtois dans votre retour car cela peut avoir un impact sur l’image de votre restaurant.
                                    </p>
                                </div>
                                <div className="mb-3">
                                    <textarea className="form-control" id="reponse" value={reponseAvis} onChange={(e) => setReponseAvis(e.target.value)} placeholder='Reponse ...' rows="3"></textarea>
                                </div>
                                <div className='d-flex justify-content-between'>
                                    <Button className='btn_cancel' onClick={() => setModalShow(false)}>Annuler</Button>

                                    {loading ? <Button className='btn btn_repondreAvis' disabled>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            variant="info"
                                            className="spiner"
                                        />
                                        Chargement...
                                    </Button> : <button className='btn btn_add' onClick={handleRepondreAvis}>Envoyer</button>}
                                </div>
                            </div>
                        </Modal.Body>


                    </Modal>
                </div>
            </div>
        </div>
    )
}

export default Avis